/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';

import ModalPreview from '@components/Section/ModalPreview'
import FileInput from '@components/FileInput';

import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';

import store from '@store';

const URL_MICROSITIO = 'https://www.complianceamx.com'
const URL_MICROSITIO_PROCESS = `${URL_MICROSITIO}/process`

class ProcessCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      languagePreview: [],
      errors: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: ''
      }
    }
    // this.initialValuesForm = {
    //     title: '',
    //     cards: [],
    // }
    this.initialValuesCardForm = {
      backgroundImg: [],
      isDisabled: false,
      isDisabledReport: false,
      isShow: true,
      processTitle: '',
      processUrl: '',
      processStatus: '',
      processUrlReport: '',
      isDisabledDocumento: false,
      showBtnDoc: false
    };
    this.initialValuesCardFormByLanguage = {
      title: '',
      btnText: '',
      description: '',
    };


    //hideDoc             === Ocultar el boton de ir a documentación
    //disabledDocumento   === Deshabilitar el botón de ir a documentación

    this.processSteps = [
      {title: "Debida Diligencia a Terceros",                                   id: 1, url: "@{/proceso?clave=PDDC}",       urlReport: "@{/proceso-seguimiento}", urlStatus: "@{/proceso?clave=PDDC}"},
      {title: "Patrocinios",                                                    id: 2, url: "@{#}",                         urlReport: "@{#}",                    urlStatus: "@{#}",                    disabledDocumento: true},
      {title: "Conflicto de Interés",                                           id: 3, url: "@{/conflicto/documentacion}",  urlReport: "@{#}",                    urlStatus: "@{/proceso?clave=PCI}"},
      {title: "Donativos",                                                      id: 4, url: "@{#}",                         urlReport: "@{#}",                    urlStatus: "@{#}",                    disabledDocumento: true},
      {title: "Prevención de Lavado de Dinero y Financiamiento al Terrorismo",  id: 5, url: "@{#}",                         urlReport: "@{#}",                    urlStatus: "@{#}",                    },
      {title: "Regalos, Gastos de Entretenimiento y Hospitalidad",              id: 6, url: "@{/regalos/documentacion}",    urlReport: "@{#}",                    urlStatus: "@{/proceso?clave=PRGE}"},
      {title: "Reportes Power BI",                                              id: 7, url: "@{/reporte-powerbi}",          urlReport: "@{#}",                    urlStatus: "@{#}"},
      {title: "Consolidado",                                                    id: 8, url: "@{/consolidado/inicio}",       urlReport: "@{#}",                    urlStatus: "@{#}"}
    ]
  }

  componentDidMount() {
    const { keysLenguages, _process, itemsTabsLenguages, t } = this.props;
    
    console.log('_process', _process)

    if (_process) {

      _process.cards = this.validateInitEditsCards(_process.cards);

      let formatCards = this.formatDetailCards(true);

      //console.log("formatCards:", formatCards)
      //console.log("_process:", _process)
      //console.log("_process.cards:", _process?.cards)

      const cards = (_process?.cards ?? []).filter(Boolean)

      /* SOS Comment
      formatCards = formatCards.reduce((accum, item) => {
        const exist = _process.cards.find(data => data.processTitle === item.processTitle)
        if(!exist) accum.push(item)
        return accum
      }, [])
      */

      formatCards = formatCards.reduce((accum, item, index) => {

        //console.log("Item en index:", index, item)

        if (!item) {
          //console.log("Item undefined detectado en index:", index)
          return accum
        }

        const exist = cards.find(data => {
          if (!data) {
            //console.log("Data undefined dentro de cards")
            return false
          }

          //console.log("Comparando:", data.processTitle, "vs", item.processTitle)

          return data.processTitle === item.processTitle

        })

        if (!exist) accum.push(item)

        return accum
      }, []);

      /* SOS
      this.setState({
        ..._process,
        cards: [..._process.cards, ...formatCards]
      });
      */

      const cleanCards = [
        ...(_process.cards ?? []),
        ...(formatCards ?? [])
      ]
        .filter(Boolean)
        .reduce((acc, item) => {
          if (!acc.some(c => c.processTitle === item.processTitle)) {
            acc.push(item);
          }
          return acc;
        }, []);

      this.setState({
        ..._process,
        cards: cleanCards
      });

      /** END SOS */

    } else {
      const formatCards = this.formatDetailCards()
      let state = {
        cards: formatCards
      }
      this.setState({...state})
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      let label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  formatDetailCards = (isEdit = false) => {
    const { keysLenguages } = this.props;
    const formatCards = this.processSteps.map(item => ({
      ...this.initialValuesCardForm,
      processTitle: item.title,
      processUrl: item.url,
      processStatus: item.urlStatus,
      processUrlReport: item.urlReport,
      processId: item.id,
      isDisabled: item.isDisabled, 
      isShow: !isEdit,
      showBtnDoc: (item.hideDoc === undefined ? false : item.hideDoc),
      isDisabledDocumento: item.disabledDocumento
    }))

    formatCards.map(option => {
      keysLenguages.map((item) => {
        option[item] = { ...this.initialValuesCardFormByLanguage }
      })
    })
    return formatCards
  }

  validateInitEditsCards = (cards) => {
    cards.map(item => {
      if (!item?.isShow) item.isShow = true
      console.log('item', item)
      if (item?.isDisabled) {
        item.isDisabled = item.isDisabled === 'true' || item.isDisabled === true
      }
      if (item?.isDisabledReport) {
        item.isDisabledReport = item.isDisabledReport === 'true' || item.isDisabledReport === true
      }
      if (!item?.processTitle) {
        // let getUrl = item.processUrl.replace(URL_MICROSITIO_PROCESS, "")
        let findTitle = this.processSteps.find(pro => pro.id === parseInt(item.processId, 10))
        item.processTitle = findTitle.title
        item.processId = findTitle.id
        item.processUrl = findTitle.url
        item.processStatus = findTitle.urlStatus
        item.processUrlReport= findTitle.urlReport
        item.isDisabled = findTitle.isDisabled
        item.showBtnDoc = (findTitle.hideDoc === undefined ? false : findTitle.hideDoc)
        item.isDisabledDocumento = findTitle.disabledDocumento
      }
      return item
    })
    return cards
  }
  

  onChangeCard = ({target}) => {
    const [index, language, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][language][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCardSimple = ({target}) => {
    const [index, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  uploadFileCard = (files, isImage, index) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    const newCard = this.state.cards
    newCard[index].backgroundImg = [data]
    this.setState({ cards: newCard }, () => this.validateFieldsOnchange(`${index}-backgroundImg`, data));
  };

  removeFileCard = (index) => {
    const newCard = this.state.cards
    newCard[index].backgroundImg = []
    this.setState({ cards: newCard });
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { cards } = this.state
    let errors = {}
    cards.map((item, index) => {
      if (item.isShow) {
        if (!item.backgroundImg.length) errors = { ...errors, [`${index}-backgroundImg`]: `${t('Imagen')} ${t('es requerido')}` }
        if (!item[LANGUAGE_DEFAULT].title) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-title`]: `${t('Titulo')} ${t('es requerido')}` }
        if (!item[LANGUAGE_DEFAULT].btnText) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-btnText`]: `${t('Texto Botón')} ${t('es requerido')}` }
        if (!item[LANGUAGE_DEFAULT].description || item[LANGUAGE_DEFAULT].description === '\n') errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}` }
      }
    })
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    let validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props
    await this.setValuesToStateGlobal()
    success();
  };

  setValuesToStateGlobal = async () =>  {
    const { cards } = this.state
    let filterCardshidden = cards.filter(item => item.isShow)
    // Validar btn status (mostrar/ocultar)
    filterCardshidden = filterCardshidden.map(item => ({...item, 
          showBtnStatus: typeof item.isDisabled === 'undefined' ? item.showBtnStatus : !item.isDisabled, 
          showBtnReport: typeof item.isDisabledReport === 'undefined' ? item.showBtnReport : !item.isDisabledReport ,
          showBtnDocumentacion: !item.showBtnDoc
        }))
    console.log("filterCardshidden", filterCardshidden)
    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { process: { cards : filterCardshidden } },
    });
  }

  onPreview = async (language) => {
    await this.setValuesToStateGlobal()

    return this.setState({showModalPreview: {
      visible: true,
      language,
    }})
  }

  onHideModalPreview = () => {
    this.setState({showModalPreview: { visible: false }})
  }

  template = (options, data, index) => {
    const { t } = this.props;
    const { cards } = this.state
    const toggleIcon = options.collapsed
      ? 'pi pi-chevron-down'
      : 'pi pi-chevron-up';
    const className = `${options.className} p-jc-beetween`;
    const titleClassName = `${options.titleClassName} p-pl-1 cursor-pointer`;

    return (
      <div className={className}>
        <div className="p-d-flex p-ai-center">
          <div className="p-d-flex p-flex-column p-mr-2">
            {index !== 0  && (
              <Button
                icon={`pi pi-chevron-up`}
                type="button"
                className="p-button-text p-button-plain"
                onClick={() => this.sortCards(index, index -1)}
              />
            )}
            { cards.length !== (index + 1) && (
              <Button
                icon={`pi pi-chevron-down`}
                type="button"
                className="p-button-text p-button-plain"
                onClick={() => this.sortCards(index, index + 1)}
              />
            )}
          </div>
          <span className={titleClassName} onClick={options.onTogglerClick} >
            {t(data.processTitle)}
          </span>
        </div>
        <div>
          <Button
            icon={`pi ${data.isShow ? 'pi-eye' : 'pi-eye-slash'}`}
            type="button"
            className="p-button-text p-button-plain"
            onClick={() => this.updateVisibility({status: data.isShow, index})}
          />
        </div>
      </div>
    );
  };

  // addService = () => {
  //   const { keysLenguages } = this.props;
  //   const newCards = this.state.cards
  //   let stateCard =  [{ ...this.initialValuesCardForm }]
  //   keysLenguages.map((item) => {
  //     stateCard[0][item] = { ...this.initialValuesCardFormByLanguage }
  //   })
  //   newCards.push(stateCard[0])
  //   this.setState({ cards: newCards })
  // };

  // removeService = (index) => {
  //   const newCards = this.state.cards
  //   newCards.splice(index, 1)
  //   this.setState({ cards: newCards })
  // };

  updateVisibility = ({status, index}) => {
    // Cambias state del card
    const newCards = this.state.cards
    newCards[index].isShow = !status
    this.setState({ cards: newCards })
  };

  sortCards = (fromIndex, toIndex) =>  {
    let cards = this.state.cards
    console.log('------- Init', cards)
    const element = cards[fromIndex];
    cards.splice(fromIndex, 1);
    cards.splice(toIndex, 0, element);
    this.setState({ cards })
}

  render() {
    const {
      t,
      btnSubmitLoading,
      itemsTabsLenguages,
      keysLenguages,
      onBack,
    } = this.props;
    const { activeTabIndex, loadingPage, showModalPreview, languagePreview, errors } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCards = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const getCards = this.state.cards;

      return getCards.map((item, index) => (
        <div className="p-col-12" key={`card-${index}`}>
          <Panel
            headerTemplate={(e) => this.template(e, item, index,)}
            collapsed={index >= 1}
            toggleable
          >
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-6 p-lg-6">
                <FileInput
                  onChangeFile={(files, isImage) => this.uploadFileCard(files, isImage, index)}
                  files={this.state.cards[index].backgroundImg}
                  removeAllFiles={() => this.removeFileCard(index)}
                  removeFile={() => this.removeFileCard(index)}
                  accept="/image*"
                  txtDrop={t('Arrastra y suelta el archivo')}
                  classNameBorderMain={classNames({
                    'p-invalid': isFormFieldValid(`${index}-backgroundImg`),
                  })}
                />
                {getFormErrorMessage(`${index}-backgroundImg`)}
              </div>
              <div className="p-col-12 p-md-6 p-lg-6"/>
              <div className="p-col-12 p-md-6 p-lg-6" />
              <div className="p-col-12">
                {itemsTabsLenguages && (
                  <TabMenu
                    model={itemsTabsLenguages}
                    activeIndex={activeTabIndex}
                    onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                  />
                )}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                {t('Título', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-title`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].title}
                  onChange={this.onChangeCard}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-title`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-title`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="description" className="p-text-bold">
                  {t('Descripción', {lng: prefixLenguage })}
                </label>
                <InputTextarea
                  name={`${index}-${prefixLenguage}-description`}
                  style={{ height: '200px' }}
                  value={this.state.cards[index][prefixLenguage].description}
                  onChange={this.onChangeCard}
                  // onTextChange={e => this.onChangeCard({target: { name: `${index}-${prefixLenguage}-description`, value: e.htmlValue }})}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-description`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-description`)}
              </div>
              <div className="p-divider p-component p-divider-horizontal p-divider-dashed p-d-flex p-jc-between" role="separator">
                <div className="p-divider-content">
                  <b>{t('Deshabilitar botón')}</b>
                </div>
                <div className="p-divider-content">
                  <InputSwitch
                    name={`${index}-isDisabled`}
                    checked={typeof this.state.cards[index].isDisabled === 'undefined' 
                          ? !this.state.cards[index].showBtnStatus
                          : this.state.cards[index].isDisabled}
                    onChange={this.onChangeCardSimple}
                  />
                </div>
              </div>
              <div className="p-divider p-component p-divider-horizontal p-divider-dashed p-d-flex p-jc-between" role="separator">
                <div className="p-divider-content">
                  <b>{t('Deshabilitar botón Reporte')}</b>
                </div>
                <div className="p-divider-content">
                  <InputSwitch
                    name={`${index}-isDisabledReport`}
                    checked={typeof this.state.cards[index].isDisabledReport === 'undefined' 
                          ? !this.state.cards[index].showBtnReport
                          : this.state.cards[index].isDisabledReport}
                    onChange={this.onChangeCardSimple}
                  />
                </div>
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="btnText" className="p-text-bold">
                {t('Texto Botón', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-btnText`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].btnText}
                  onChange={this.onChangeCard}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-btnText`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-btnText`)}
              </div>
            </div>
          </Panel>
        </div>
      ));
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            {/* <div className="p-col-12 p-text-right p-d-flex p-jc-end">
              <Button
                label={t("Agregar bloque")}
                type="button"
                className="p-button-info"
                onClick={() => this.addService()}
                style={{width: '150px'}}
              />
            </div> */}
            {renderCards()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-primary"
                model={languagePreview}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          { showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _process: state.section.process,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(ProcessCards);
